'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function formatProp(value) {
    if (typeof value === 'string') {
        return "\"" + value + "\"";
    }
    if (typeof value === 'number') {
        return value;
    }
    if (value == null || typeof value === 'boolean') {
        return "{" + value + "}";
    }
    return JSON.stringify(value);
}

function getComponentName(Component) {
    return Component.displayName || Component.name || 'Unknown';
}

function elementWithProps(Component, expectedProps) {
    var requiredComponentName = getComponentName(Component);
    function validator(props, propName, componentName) {
        var rest = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            rest[_i - 3] = arguments[_i];
        }
        var propValue = props[propName];
        if (!propValue) {
            throw new TypeError(componentName + " must provide `" + propName + "` prop which equal to react element " + requiredComponentName + ", e.g: <" + componentName + " " + propName + "={<" + requiredComponentName + " />} />");
        }
        var passedComponentName = getComponentName(propValue.type);
        if (passedComponentName !== requiredComponentName) {
            throw new TypeError(componentName + " must provide `" + propName + "` prop with react element `" + requiredComponentName + "`, but found `" + passedComponentName + "`");
        }
        Object.keys(expectedProps).forEach(function (expectedProp) {
            var innerProps = propValue.props;
            var innerValue = innerProps[expectedProp];
            var expectedValue = expectedProps[expectedProp];
            if (typeof expectedValue === 'function') {
                // assume it's another propTypes because there's no use case for comparing two function
                var result = expectedValue.apply(void 0, [innerProps,
                    expectedProp,
                    requiredComponentName].concat(rest));
                if (result) {
                    throw result;
                }
                // we return early to allow optional props
                return;
            }
            // if we're comparing value (instead of another prop types), we need to make sure that the inner prop value is defined
            if (innerValue === undefined) {
                throw new TypeError("Expected `" + requiredComponentName + "` to be rendered with props `" + expectedProp + "`, e.g: <" + componentName + " " + propName + "={<" + requiredComponentName + " " + expectedProp + "=" + formatProp(expectedValue) + " />} />");
            }
            if (innerValue !== expectedValue) {
                throw new TypeError("Invalid prop " + expectedProp + "=" + formatProp(innerValue) + " supplied to `" + requiredComponentName + "`, expected " + expectedProp + "=" + formatProp(expectedValue));
            }
        });
    }
    return validator;
}

exports.ElementWithProps = elementWithProps;
